import { _axios } from "../../../Utils/Axios/axios";

export const editProfileService = async (
  userToken: string,
  fullName: string,
  cityId: string,
  gradeId: string
) => {
  const data = new FormData();

  data.append("fullName", fullName);
  data.append("city_id", cityId);
  data.append("grade_id", gradeId);

  return _axios.put(
    "/profile/0",
    {
      fullName,
      grade_id: gradeId,
      city_id: cityId,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
